import { useAppMetaTag } from '@/hooks/useAppMetaTag';
import { useSubscriptionFlagsTracking } from '@/features/subscriptions/hooks';

/**
 * Provider that handles miscellaneous app-level functionality
 * - Apple Smart App Banner meta tag management
 * - Subscription flags tracking from URL params (mirrors Vue's trackTraffic)
 */
export function MiscProvider({ children }: { children: React.ReactNode }) {
    // Handle Apple Smart App Banner meta tag on route changes
    useAppMetaTag();

    // Save subscription flags from URL params to cookies on app load
    // This ensures flags like show_promo, code, annual, etc. are persisted
    // before the user navigates away from the initial landing page (e.g., /register)
    useSubscriptionFlagsTracking();

    return <>{children}</>;
}
